/**
 * R-34 — Wizard banner when cross-tab bootstrap wait times out.
 */
import React from 'react';
import { Loader2 } from 'lucide-react';
import type { SiteEntity } from '../../types/site';

interface Props {
  site: SiteEntity;
  /** Local flag when `bootstrapSedCoordinated` returned `timedOut: true`. */
  timedOut?: boolean;
}

export const SedCrossTabWaitBanner: React.FC<Props> = ({ site, timedOut }) => {
  const lockHeld = site.sedBootstrapLockStatus === 'locked';
  const waiting = lockHeld && site.sedStatus !== 'bootstrapping';
  if (!timedOut && !waiting) return null;

  return (
    <div
      role="status"
      data-testid="sed-cross-tab-wait-banner"
      data-state={timedOut ? 'timed-out' : 'waiting'}
      className="mx-5 my-3 rounded-md border border-warning/40 bg-warning/10 px-4 py-3 text-[10px] text-text-secondary"
    >
      <div className="flex items-start gap-2">
        <Loader2 className="w-3.5 h-3.5 text-warning shrink-0 mt-0.5 animate-spin" />
        <div className="space-y-1">
          <p className="type-section text-warning">
            Another tab is rebuilding the SED…
          </p>
          <p className="leading-relaxed">
            {timedOut
              ? 'This tab waited over a minute for the other rebuild to finish. You can keep waiting, switch to the other tab, or ask an admin to break the lock.'
              : 'Waiting for another browser tab to finish rebuilding site evidence. This tab will continue automatically when the rebuild completes.'}
          </p>
        </div>
      </div>
    </div>
  );
};
